import { Node } from "@tiptap/core";
import { ReactNodeViewRenderer } from "@tiptap/react";

import NodeWithTranslation from "@/view/TiptapArticleBody/components/NodeWithTranslation";
import { ComponentProps } from "@/view/TiptapArticleBody/TiptapArticleBody.interface";
import { rootCss } from "./PreformattedBlock.style";

export interface PreformattedBlockOptions {
  disableTranslation?: boolean;
}

export const PreformattedComponent = ({
  editor,
  node,
  extension,
}: ComponentProps<PreformattedBlockOptions>) => {
  const identifier = `${node.attrs["data-identifier"] || ""}`;
  const { disableTranslation = false } = extension?.options;

  return (
    <NodeWithTranslation
      state={editor.state}
      node={node}
      props={{ css: rootCss, "data-identifier": identifier, as: "pre" }}
      disableTranslation={disableTranslation}
    />
  );
};

export const PreformattedBlock = Node.create<PreformattedBlockOptions>({
  name: "pre_block",
  content: "text*",
  group: "inline",
  inline: true,
  addAttributes() {
    return {
      "data-identifier": {
        default: null,
      },
    };
  },
  addOptions() {
    return {
      disableTranslation: false,
    };
  },
  renderHTML() {
    return ["pre", 0];
  },
  addNodeView() {
    return ReactNodeViewRenderer(PreformattedComponent, {
      contentDOMElementTag: "p",
    });
  },
});
